// Determines whether we're on Android Parent app.
export const isAndroidParent = navigator.userAgent.startsWith('OurPact_Android')
